var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gradient-value",style:(_vm.style)},[_c('span',[_vm._v("$"+_vm._s(parseInt(this.value).toLocaleString()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }